import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DOMESTIC, wa, slug } from "../lib/site";
import { MaskLines, Reveal, SectionEyebrow } from "./Reveal";
import { WhatsAppIcon } from "./WhatsAppIcon";

const Card = ({ d, i }) => (
  <motion.a
    href={wa(`Hi, I want more information about the ${d.name} tour package`)}
    target="_blank" rel="noopener noreferrer"
    data-testid={`domestic-card-${slug(d.name)}`}
    initial={{ opacity: 0, y: 60 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: (i % 3) * 0.08 }}
    className={`group relative block overflow-hidden rounded-[28px] bg-ink ${d.span}`}
  >
    <img src={d.img} alt={`${d.name} - ${d.tag}`} loading="lazy"
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-110" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
    <div className="absolute inset-0 bg-go mix-blend-multiply opacity-0 transition-opacity duration-500 group-hover:opacity-50" />
    <div className="absolute left-5 top-5 flex items-center gap-2 rounded-full bg-white/90 backdrop-blur px-3 py-1 font-mono text-[11px] font-bold tracking-[0.2em] text-ink">
      BOM <span className="text-go">✈</span> {d.code}
    </div>
    <div className="absolute right-5 top-5 grid h-11 w-11 place-items-center rounded-full bg-go text-ink transition-transform duration-500 group-hover:rotate-45 group-hover:scale-110">
      <ArrowUpRight size={20} />
    </div>
    <div className="absolute inset-x-5 bottom-5 text-white">
      <h3 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{d.name}</h3>
      <p className="mt-1 text-sm text-zinc-200">{d.tag}</p>
      <span className="mt-3 inline-flex max-h-0 items-center gap-2 overflow-hidden rounded-full bg-[#25D366] px-3 text-xs font-bold text-ink opacity-0 transition-[max-height,opacity,padding] duration-500 group-hover:max-h-10 group-hover:py-1.5 group-hover:opacity-100">
        <WhatsAppIcon className="h-3.5 w-3.5" /> Chat for package details
      </span>
    </div>
  </motion.a>
);

export const Domestic = () => (
  <section id="domestic" className="relative bg-paper py-24 sm:py-32" data-testid="domestic-section">
    <div className="mx-auto max-w-7xl px-5">
      <div className="mb-14 grid gap-6 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-8">
          <SectionEyebrow index="01" label="Domestic Tours & Travels" />
          <h2 className="mt-5 font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-[0.92] tracking-[-0.035em] text-ink">
            <MaskLines lines={["Popular Domestic", <span key="d">Destinations<span className="text-go">.</span></span>]} />
          </h2>
        </div>
        <Reveal className="lg:col-span-4" delay={0.2}>
          <p className="text-base md:text-lg text-zinc-700 leading-relaxed" data-testid="domestic-subtext">
            For details and custom tour packages, tap any destination to chat with us on WhatsApp!
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-12 auto-rows-[300px] md:auto-rows-[280px] lg:auto-rows-[250px]">
        {DOMESTIC.map((d, i) => <Card key={d.name} d={d} i={i} />)}
      </div>
    </div>
  </section>
);
